import { render } from "./StaticPage.vue?vue&type=template&id=4ac465ca"
import script from "./StaticPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StaticPage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Public/StaticPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ac465ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ac465ca', __exports__)) {
    api.reload('4ac465ca', __exports__)
  }
  
  module.hot.accept("./StaticPage.vue?vue&type=template&id=4ac465ca", () => {
    api.rerender('4ac465ca', render)
  })

}


export default __exports__